import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const customsDeclarationStatusEnum = createEnum({
    PENDING: ['pending', '待申报', 'default'],
    PROCESSING: ['processing', '申报中', 'processing'],
    DECLARED: ['declared', '已申报', 'success'],
});
export const CUSTOMS_DECLARATION_STATUSES = enumValues(customsDeclarationStatusEnum);
export const CUSTOMS_DECLARATION_STATUS_LABEL_MAP = enumLabelMap(customsDeclarationStatusEnum);
//# sourceMappingURL=customs-declaration.js.map